<template>
  <div :class="['page', `bg-${bgType}`, { 'bg-unable': isTaskUnable }]">
    <div class="block-content" @click="handleUnableClick">
      <div class="block-content-descript">
        <div class="block-content-descript-title">
          {{ dailyTaskName }}
        </div>
        <div class="block-content-descript-sub" v-if="bgType != 'display'">
          {{ dailyTaskDescription }}
        </div>
      </div>
      <div class="block-points">
        <div class="block-points-text">
          +{{ dailyPoints ? dailyPoints.toLocaleString("en") : 0 }}
        </div>
        <div class="block-points-text-sub">MPT</div>
      </div>
      <div class="block-content-row" v-if="bgType != 'display'">
        <div class="block-content-icon">
          <img :src="dailyTaskIcon" draggable="false" v-if="dailyTaskIcon" />
          <img
            :src="require('@/assets/images/moonpoints/' + dailyTaskIconLocal)"
            draggable="false"
            v-if="!dailyTaskIcon && dailyTaskIconLocal"
          />
        </div>
        <div class="block-check" v-if="isDailyCheck">
          <div class="block-check-text">✓</div>
        </div>

        <div class="block-claim" v-if="!isDailyCheck">
          <div
            :class="[
              'block-claim-btn',
              { 'block-claim-btn-disable': !isCanClaim },
              { 'block-claim-btn-unable': isTaskUnable },
            ]"
            @click="handleClaimClick"
          >
            <div
              class="block-claim-btn-text"
              v-show="!(isRequestLoading && RequestLoadingId === dailyTaskId)"
            >
              {{
                localesPackage?.["task_list_btn_claim"]?.[localesEnv] || "Claim"
              }}
            </div>
            <div
              class="block-claim-btn-loading"
              v-show="isRequestLoading && RequestLoadingId === dailyTaskId"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="block-bg-unable" v-if="isTaskUnable"></div> -->
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { mapState } from "vuex";

export default {
  components: {},
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    data: {
      handler(value) {
        this.handleInit(value);
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        if (value) {
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if (value) {
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: 1,
    },
    isRequestLoading: {
      type: Boolean,
      default: false,
    },
    RequestLoadingId: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref("en");

    const taskItem = ref(null);
    const isTaskUnable = ref(false);
    const isTaskDisplay = ref(false);
    const isDailyCheck = ref(false);
    const isCanClaim = ref(false);

    const dailyTaskId = ref("");
    const dailyTaskIcon = ref("");
    const dailyTaskIconLocal = ref("");
    const dailyTaskName = ref("");
    const dailyTaskDescription = ref("");
    const dailyPoints = ref(0);
    const bgType = ref("sync");

    const handleInit = (item) => {
      taskItem.value = item;

      const id = item?.id || "";
      const name = item?.name || "";
      const i18n_name = item?.i18n_name || "";
      const description = item?.description || "";
      const description_local = item?.description_local || "";
      let i18n_desc = item?.i18n_desc || "";
      const image_url = item?.image_url || "";
      const image_local = item?.image_local || "";
      const bg_type = item?.bg_type || "sync";

      const is_claimed = item?.is_claimed || false;

      const completed_count = item?.completed_count || 0;
      const count = item?.count || 0;
      const is_check_done = item?.is_check_done;

      const _isLocalFinish = item?._isLocalFinish;
      const _isCanClaim = is_check_done
        ? completed_count >= count
        : _isLocalFinish;

      const isUnable = item?.isUnable || false;
      const isDisplay = item?.isDisplay || false;

      const mission_reward = item?.mission_reward || null;
      const key = mission_reward?.key;
      const is_prop = mission_reward?.is_prop;
      const amount = mission_reward?.amount || "0";

      const _amount = amount ? amount.toLocaleString("en") : "0";
      i18n_desc = i18n_desc.replace("{a}", _amount);

      dailyTaskId.value = id;
      dailyTaskIcon.value = image_url;
      dailyTaskIconLocal.value = image_local;
      dailyTaskName.value = i18n_name || name;
      dailyTaskDescription.value =
        i18n_desc || description || description_local;

      isTaskUnable.value = isUnable;
      isTaskDisplay.value = isDisplay;
      isDailyCheck.value = is_claimed;
      isCanClaim.value = _isCanClaim;

      dailyPoints.value = amount;

      bgType.value = bg_type;
    };

    const handleUnableClick = () => {
      if (isTaskUnable.value || isTaskDisplay.value) {
        console.log("handleUnableClick");
        emit("onUnable", taskItem.value);
      }
    };

    const handleClaimClick = () => {
      if (isTaskUnable.value || isTaskDisplay.value) return;

      if (!isCanClaim.value || isDailyCheck.value) {
        return;
      }

      emit("onClaim", taskItem.value);
    };

    return {
      taskItem,
      isTaskUnable,
      isTaskDisplay,
      dailyPoints,
      isDailyCheck,
      isCanClaim,
      dailyTaskId,
      dailyTaskIcon,
      dailyTaskIconLocal,
      dailyTaskName,
      dailyTaskDescription,
      handleInit,
      handleUnableClick,
      handleClaimClick,
      localesPackage,
      localesEnv,
      bgType,
    };
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  border-radius: 24px;
  padding: 16px 12px;
  position: relative;
  font-family: "Inter";
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .block-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    &-descript {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      text-align: left;

      &-title {
        align-self: stretch;
        color: #ffffff;
        font-family: "Inter";
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      &-sub {
        color: #ffffffbf;
        text-align: left;
        font-family: "Inter";
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-top: 2px;

        scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
      }
    }
  }

  .block-points {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    margin-top: 8px;

    &-text {
      color: #ffca43;
      font-family: "Inter";
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 29px;

      &-sub {
        color: #ffca43;
        font-family: "Inter";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 29px;
        text-transform: uppercase;
        margin-left: 4px;
      }
    }
  }

  .block-content-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;
    margin-top: 24px;

    .block-content {
      &-icon {
        flex-shrink: 0;
        width: 32px;
        height: 32px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .block-check {
      width: 47px;
      height: 32px;
      // padding: 8px 16px;
      justify-content: center;
      align-items: center;
      border-radius: 34px;
      border: 1.5px solid #0dff7a;
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;

      &-text {
        color: #0dff7a;
        font-family: "Inter";
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }

    .block-claim {
      &-btn {
        width: 76px;
        height: 32px;
        // padding: 8px 16px;
        border-radius: 34px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: linear-gradient(90deg, #ff59c6 0%, #fdad63 100%);
        box-sizing: border-box;

        &-text {
          color: #ffffff;
          font-family: "Inter";
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
        }

        &-disable {
          background: #ffffff26;

          .block-claim-btn-text {
            color: #ffffff99;
          }
        }

        &-unable {
          background: #ffffff26;

          .block-claim-btn-text {
            color: #ffffff80;
          }
        }

        &-loading {
          width: 20px;
          height: 20px;
          padding-top: 0px;
          background-image: url("~@/assets//images/common/loading/icon_loading_w.png");
          background-size: 100%;

          animation-name: rote;
          animation-duration: 1s;
          animation-iteration-count: infinite;
        }

        @keyframes rote {
          form {
            transform: rotate(0deg);
          }

          to {
            transform: rotate(360deg);
          }
        }
      }
    }
  }

  .block-bg-unable {
    position: absolute;
    left: 0px;
    right: 1px;
    top: 0px;
    bottom: 0px;
    border-radius: 10px;
    border-top-right-radius: 0px;
    background-color: rgba(102, 102, 102, 0.5);
    pointer-events: none;
  }
}

.bg {
  &-kcal {
    background: linear-gradient(180deg, #94354b 55%, #875731 100%), #ffffff14;
  }

  &-sync {
    background: linear-gradient(180deg, #972b97 0%, #824633 100%);
  }

  &-heart {
    background: linear-gradient(0deg, #844949 0%, #8f3434 60%);
  }

  &-step {
    background: linear-gradient(180deg, #8f5438 55%, #726831 100%), #ffffff14;
  }

  &-sleep {
    background: linear-gradient(180deg, #4b4294 55%, #3a6692 100%), #ffffff14;
  }

  &-unable {
    background: #66666680;
  }

  &-display {
    background: linear-gradient(180deg, #9035e0 0%, #4345cc 50.1%, #3d208c 100%),
      linear-gradient(180deg, #9035e0 0%, #4547c8 50.1%, #290f71 100%),
      #ffffff14;
  }

  &-chats {
    background: linear-gradient(180deg, #3b5a95 55%, #43749f 100%);
  }

  &-online {
    background: linear-gradient(180deg, #574294 55%, #843f7f 100%);
  }
}
</style>
